import React, { useEffect, useState } from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';
import api from '../../api';

/**
 * PlayersSelector
 * Props:
 * - selectedClasse, setSelectedClasse
 * - player1, setPlayer1
 * - player2, setPlayer2
 *
 * Loads classes (for prof) and students for selected class.
 */
export default function PlayersSelector({ selectedClasse, setSelectedClasse, player1, setPlayer1, player2, setPlayer2 }) {
  const [classes, setClasses] = useState([]);
  const [eleves, setEleves] = useState([]);
  const [loadingClasses, setLoadingClasses] = useState(true);
  const [loadingEleves, setLoadingEleves] = useState(false);

  useEffect(() => {
    let mounted = true;
    setLoadingClasses(true);
    api.get('/classes').then(res => {
      if (!mounted) return;
      setClasses(Array.isArray(res.data) ? res.data : []);
    }).catch(err => {
      console.warn('Impossible de charger classes', err);
      setClasses([]);
    }).finally(() => { if (mounted) setLoadingClasses(false); });
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    if (!selectedClasse) {
      setEleves([]);
      return;
    }
    let mounted = true;
    setLoadingEleves(true);
    api.get(`/eleves?classe=${encodeURIComponent(selectedClasse)}`).then(res => {
      if (!mounted) return;
      setEleves(Array.isArray(res.data) ? res.data : []);
    }).catch(err => {
      console.warn('Impossible de charger élèves', err);
      setEleves([]);
    }).finally(() => { if (mounted) setLoadingEleves(false); });
    return () => { mounted = false; };
  }, [selectedClasse]);

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
      <FormControl fullWidth>
        <InputLabel id="classe-select">Classe</InputLabel>
        <Select
          labelId="classe-select"
          value={selectedClasse || ''}
          label="Classe"
          onChange={e => setSelectedClasse(e.target.value)}
        >
          <MenuItem value="">Sélectionner</MenuItem>
          {loadingClasses
            ? <MenuItem disabled>Chargement...</MenuItem>
            : classes.map(c => <MenuItem key={c._id} value={c._id}>{c.nom || c.name}</MenuItem>)
          }
        </Select>
      </FormControl>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <FormControl fullWidth>
          <InputLabel id="player1-select">Joueur 1</InputLabel>
          <Select
            labelId="player1-select"
            value={player1 || ''}
            label="Joueur 1"
            onChange={e => setPlayer1(e.target.value)}
            disabled={!selectedClasse || loadingEleves}
          >
            <MenuItem value="">Sélectionner</MenuItem>
            {loadingEleves
              ? <MenuItem disabled>Chargement...</MenuItem>
              : eleves.map(el => <MenuItem key={el._id} value={el._id}>{el.prenom} {el.nom}</MenuItem>)
            }
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel id="player2-select">Joueur 2</InputLabel>
          <Select
            labelId="player2-select"
            value={player2 || ''}
            label="Joueur 2"
            onChange={e => setPlayer2(e.target.value)}
            disabled={!selectedClasse || loadingEleves}
          >
            <MenuItem value="">Sélectionner</MenuItem>
            {loadingEleves
              ? <MenuItem disabled>Chargement...</MenuItem>
              : eleves.map(el => <MenuItem key={el._id} value={el._id}>{el.prenom} {el.nom}</MenuItem>)
            }
          </Select>
        </FormControl>
      </Box>

      {!selectedClasse && (
        <Typography variant="caption" sx={{ gridColumn: '1 / -1', color: 'text.secondary' }}>
          Sélectionne une classe pour charger les élèves.
        </Typography>
      )}
    </Box>
  );
}